import {
  FETCH_DSP_USER_SUCCESS,
  FETCH_DSP_USER_REQUEST,
  FETCH_DSP_USER_FAILURE
} from "../actions/fetchDSPUserProfile/types";

const initialState = {
  userProfileData: [],
  loading: false,
  error: null,
  lastFetched: null
};

export default function dSPUserReducer(state = initialState, action) {
     switch (action.type) {
        case FETCH_DSP_USER_SUCCESS:
            return { ...state, userProfileData: action.payload, lastFetched: action.lastFetched, loading: false };
        case FETCH_DSP_USER_REQUEST:
            return { ...state, loading: true };
        case FETCH_DSP_USER_FAILURE:
            return { ...state, loading: false, error: action.error }
        default:
            return state;
     }
}